import React, { useState } from 'react';
import './ManageProjectDialog.css';

const CloseIcon = () => (
  <svg
    className="close-button__icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <line x1="6" y1="6" x2="18" y2="18" />
    <line x1="18" y1="6" x2="6" y2="18" />
  </svg>
);

const ManageProjectDialog = ({ project, onClose, onSaveName, onDelete }) => {
  const [projectName, setProjectName] = useState(project.projectName);

  const handleSave = () => {
    if (projectName.trim() !== '') {
      onSaveName(project.id, projectName);
    }
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <button
          type="button"
          onClick={onClose}
          className="close-button"
          aria-label="Close settings"
        >
          <CloseIcon />
        </button>
        <h3>Manage Project</h3>
        <div className="form-group">
          <label htmlFor="projectName">Project Name</label>
          <div className="input-group">
            <input
              id="projectName"
              type="text"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              className="project-name-input"
            />
            <button onClick={handleSave} className="btn-teal">Save</button>
          </div>
        </div>
        <div className="delete-section">
          <button onClick={() => onDelete(project.id)} className="btn-red">Delete Project</button>
        </div>
      </div>
    </div>
  );
};

export default ManageProjectDialog;
